<template>
    <div id="errorBox">
        <!-- 感谢完善遮罩 -->
        <div class="maskBox" v-show="maskShow">
            <div class="maskInner">
                <!-- <p class="title">感谢完善</p> -->
                <p class="content">您完善的内容已收到，我们将尽快审核</p>
                <div class="sureBtn" @click="intoMsg">确定</div>
            </div>
        </div>
        <div id="headers">
            <i class="arr" @click="goBack()"></i>
            <p class="title">{{title}}</p>
        </div>
        <div class="setFix"></div>
        <div class="warn">
            示例：分类[物业]，名称[物业办公室]，电话[01088888888]，位置：[选择地图]，详细地址[4号楼3单元102室]
        </div>
        <form action="">
            <div class="row">
                <label for="">分类</label>
                <div type="text" class="kinds" :class="[checkSele ? 'up' : '', form.typeId ? 'selected' : '', '纠错' === title ? 'disabled' : '']" @click="showSele()">{{form.flname}}</div>
            </div>
            <ul class="seleList" v-show="checkSele">
                <li v-for="(item, index) in arrList" :key="index" @click="hideSele(item.typeName,index,item._id)" :class="{'active': index == current || form.typeId == item._id}">{{item.typeName}}</li>
            </ul>
            <mt-field class="addtag" label="名称" placeholder="例：物业办公室" type="text" v-model="form.name"></mt-field>
            <mt-field class="addtag" label="电话" placeholder="请输入要补充的电话" type="number" v-model="form.phone"></mt-field>
            <!-- <mt-field label="位置" placeholder="请选择要完善的位置信息" type="url" v-model="form.website"></mt-field> -->
            <div class="row prow" @click="intoMap">
                <label for="" class="position">位置</label>
                <!-- <div type="text" class="kinds adkinds" :class="hasAddress ? 'selected' : ''" @click="intoMap">{{form.address}}</div> -->
                <mt-field style="border-bottom:0;color:#666 !important;background-color:#fff !important;width:70%;" class="kinds adkinds paddress"  placeholder="请在地图中选择位置" readonly='readonly' disabled="disabled" type="text" :class="hasAddress ? 'selected' : ''" @click="intoMap" v-model="form.address"></mt-field>
            </div>
            <!-- <mt-field label="详细地址" placeholder="请输入要完善的详细地址" type="number" v-model="form.number"></mt-field> -->
            <mt-field label="详细地址" class="detailAddress" placeholder="例：4号楼3单元501室" type="textarea" rows="2" v-model="form.detailAddress"></mt-field>
        </form>
        <div v-show="isBtm">
            <mt-picker :slots="slots" @change="onValuesChange" v-model="chioceList"></mt-picker>
        </div>
        <mt-button type="danger" class="submitBtn" :class="jcMsg['address'] == form['detailAddress']
                        && jcMsg['mapAddress'] == form['address']
                        && jcMsg['phone'] == form['phone']
                        && jcMsg['name'] == form['name'] ? 'disabled' : ''" @click.stop="submitForm()">提交</mt-button>
    </div>
</template>

<script>
import { MessageBox, Toast } from 'mint-ui';
import axios from 'axios';
import Top from '@/component/top/top'
import {mapState, mapMutations} from 'vuex'
export default {
    data() {
        return {
            moveTime:this.getMovetime(),
            userpoiId:this.getcurrentuserCommunity().poiId,
            maskShow:false,
            isBtm:false,
            chioceList:'',
            jcMsg:{},
            checkSele:false,
            current:-1,
            title:'',
            arrList:[],
            infoId:'',
            hasAddress: false,
            form:{
                typeId: '',
                flname:'请选择要完善的分类',
                name:'',
                phone:'',
                website:'请选择要完善的位置信息',
                number:'',
                detailAddress:'',
                address:''
            },
            slots:[
                {
                    flex: 1,
                    values: ['2015-01', '2015-02', '2015-03', '2015-04', '2015-05', '2015-06'],
                    className: 'slot1'
                }
            ],
            kindLists:[]
        }
    },
    components:{
        Top
    },
    created() {
        this.title=this.$route.query.title
        this.getKinds()
        if(this.$route.query.title=="纠错") {
            let _jcMsg = JSON.parse(localStorage.getItem('jcMsg'))
            this.jcMsg = _jcMsg
            this.form = {
                flname:_jcMsg['typeName'],
                name:_jcMsg['name'],
                phone:_jcMsg['phone'],
                detailAddress:_jcMsg['address'],
            }
            this.form.typeId = _jcMsg["typeId"]
            
            this.form.address = this.$route.query.ads || _jcMsg['mapAddress']
            this.hasAddress = true
        } else {
            let _form = JSON.parse(localStorage.getItem('addMsg'))
            if(_form) {
                this.form = _form
                localStorage.removeItem('addMsg')
            }
            if(this.$route.query.ads) {
                this.form.address = this.$route.query.ads
                // this.infoId = localStorage.getItem("id")
                this.hasAddress = true
            }
        }
        this.form.lng = this.$route.query.lng
        this.form.lat = this.$route.query.lat
    },
    methods:{
        showBtm() {
            this.isBtm = true
        },
        onValuesChange() {

        },
        showSele() {
            if(this.$route.query.title=='纠错') {
                return
            }else{
                this.checkSele = !this.checkSele
            }
        },
        hideSele(name, i, id) {
            this.current = i
            this.form.flname = name
            this.checkSele = false
            this.form.typeId = id
            localStorage.setItem('id',id)
        },
        // 提交
        submitForm() {
            if(this.$route.query.title=='纠错') {
                if(this.jcMsg['address'] == this.form['detailAddress']
                        && this.jcMsg['mapAddress'] == this.form['address']
                        && this.jcMsg['phone'] == this.form['phone']
                        && this.jcMsg['name'] == this.form['name']) {
                    return;
                }
                axios.post(this.commonIp()+'/v1/communityInfo/report',{
                    department :this.form.name,
                    contact:this.form.phone,
                    lng: this.form.lng || this.jcMsg['lng'],
                    lat: this.form.lat || this.jcMsg['lat'],
                    poiId :this.$route.query.id,
                    address:this.form.detailAddress,
                    mapAddress:this.form.address.length==0?'':this.form.address,
                    token :this.getuserToken(),
                    infoId: this.form.typeId
                }).then((res) => {
                    if(res.data.code==200) {
                        this.maskShow = true
                    }else{
                        Toast(res.data.message);
                    }
                }).catch((error) => {
                    Toast('提交失败')
                })
            }else{
                axios.post(this.commonIp()+'/v1/communityInfo/create',{
                    typeId :this.form.typeId,
                    department:this.form.name,
                    contact: this.form.phone,
                    lng: this.form.lng || '',
                    lat: this.form.lat || '',
                    poiId :this.$route.query.id,
                    token :this.getuserToken(),
                    address:this.form.detailAddress,
                    mapAddress:this.form.address.length==0?'':this.form.address,
                }).then((res) => {
                    if(res.data.code=='200') {
                        this.maskShow = true
                    }else{
                        Toast(res.data.message)
                    }
                }).catch((error) => {
                    Toast('提交失败')
                    console.log(error)
                })
            }
        },
        // 点击我知道了
        intoMsg() {
            this.maskShow = false
            this.$router.push({path:`/sqmsg?id=${this.$route.query.id}`})
        },
        getKinds() {
            axios.get(this.commonIp()+'/v1/communityInfo/types').then((res) => {
                this.arrList = res.data.data[1]
            })
        },
        // 进入地图
        intoMap() {
            if(this.$route.query.title=='补充信息') {
                localStorage.setItem('addMsg',JSON.stringify(this.form))
                this.$router.push({
                    path : '/map',
                    query : {
                        title : '补充信息',
                        id : this.$route.query.id,
                        lng : this.form.lng || (localStorage.getItem('lon') || ''),
                        lat : this.form.lat || (localStorage.getItem('lat') || ''),
                        address:this.form.address=='' ? '' : this.form.address,
                        // address:this.form.address=='请在地图中选择位置' ? '' : this.form.address,
                        userpoiId:this.userpoiId
                    }
                })
            }else{
                let _jcMsg = {}
                _jcMsg['typeName'] = this.form.flname
                _jcMsg['name'] = this.form.name
                _jcMsg['phone'] = this.form.phone
                _jcMsg['address'] = this.form.detailAddress
                _jcMsg['mapAddress'] = this.form.address
                _jcMsg["typeId"] = this.form.typeId
                localStorage.setItem('jcMsg', JSON.stringify(_jcMsg))
                this.$router.push({
                    path:'/map',
                    query:{
                        title:'纠错',
                        id:this.$route.query.id,
                        lng:this.form.lng || (this.jcMsg['lng'] || ''),
                        lat:this.form.lat || (this.jcMsg['lat'] || ''),
                        // address: this.form.address=='请在地图中选择位置' ? '' : this.form.address,
                        address: this.form.address=='' ? '' : this.form.address,
                        userpoiId:this.userpoiId
                    }
                })
            }
        },
        goBack() {
            this.$router.push({path:'/sqmsg',query:{id:this.$route.query.id}})
        },
    }
}
</script>
<style lang="less">
@import '~@/assets/less/index.less';
    .mint-msgbox-confirm{
        color:#23b355
    }
    .mint-field.is-textarea .mint-cell-value{
        padding:0 10px 0 0;
    }
    #errorBox{
        .mint-cell-wrapper{
            background: none;
            border-bottom:1px solid #d8d8d8;
        }
    }
    #errorBox .detailAddress .mint-field-core{
        margin-bottom:1px;
        font-size:@ft14;
    }
    .warn{
        background:#F2F2F2;
        color:@gray;
        font-size:@ft12;
        padding:10px;
    }
    .maskBox{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index:1;
        background: rgba(0, 0, 0, 0.5);
        .maskInner {
            padding: 25px 28px;
            width: 286px;
            height: 152px;
            background: #fff;
            position: fixed;
            box-sizing: border-box;
            top: 50%;
            left: 50%;
            margin-top: -76px;
            margin-left: -143px;
            border-radius: 10px;
            z-index: 2;
            text-align:center;
            .title {
                font-size: @ft18;
                color: #323232;
                font-weight: bold;
                margin: 0 0 20px 0;
                text-align: center;
            }
            .content{
                color:#323232;
                font-size:@ft14;
            }
            .sureBtn {
                height: 40px;
                line-height: 40px;
                text-align: center;
                font-size: @ft16;
                background: #25cf8d;
                border-radius: 5px;
                margin:20px 0 0 0;
                color: #fff;
            }
        }
    }
    #errorBox{
        .submitBtn {
            &.disabled {
                background: gray;
            }
        }
        form{
            overflow: hidden;
        }
        .mint-cell-text{
            position: relative;
        }
        .mint-cell-title{
            padding:0 0 0 10px;
        }
        .mint-cell-wrapper{
            padding:0;
        }
        .addtag{
            .mint-cell-title::after{
                color:red;
                content:'*';
                vertical-align: bottom;
            }
            &:first-child{
                .mint-cell-wrapper{
                    background-image:none;
                }
            }
        }
        .detailAddress{
            .mint-field-core{
                // color:#888;
                font-family: '微软雅黑';
                margin-top:25px;
            }
        }
        .mint-field-core{
            padding-right: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size:@ft14;
        }
        .row{
            min-height:48px;
            display: flex;
            align-items: center;
            border-bottom:1px solid #d8d8d8;
            position: relative;
            &:first-child{
                border-top:0;
            }
            label{
                width:105px;
                padding:0 0 0 10px;
                flex:0 0 105px;
                &:after{
                    color:red;
                    content:'*';
                    vertical-align: bottom;
                }
                &.position:after{
                    display: none;
                }
            }
            .kinds{
                height:48px;
                line-height: 48px;
                outline: none;
                padding:0 10px 0 0;
                background:url('~@/assets/imgs/down.png') no-repeat right center #fff;
                background-size:14px;
                width:66%;
                margin:0 15px 0 0;
                color:#888;
                font-size:@ft14;
                &.up{
                    background-image:url('~@/assets/imgs/up.png');
                }
                &.adkinds{
                    background-image:url('~@/assets/imgs/r.png');
                    background-size:10px;
                }
                &.paddress{
                    .mint-field-core{
                        color:#000 !important;
                        opacity:1;
                        font-weight: 600;
                        background: #fff;
                    }
                }
                &.selected {
                    color: #000;
                }
                &.disabled {
                    background: none;
                    color:#b3b3b3;
                }
            }
        }
        .prow{
            .mint-cell-wrapper{
                border-bottom:0;
                color:#666;
            }
        }
        .seleList{
            width:70%;
            background:#fff;
            z-index:1;
            margin:0 0 0 105px;
            li{
                text-align: left;
                color:@gray;
                font-size:@ft15;
                padding:0 0 0 30px;
                background: url('~@/assets/imgs/circle.png') no-repeat left center;
                line-height: 40px;
                background-size:18px;
                &.active{
                    background-image:url('~@/assets/imgs/circle2.png');
                }
            }
        }
        .mint-button--danger{
            background:#25cf8d ;
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/errcon/errcon.vue